import { toast } from "react-toastify";

const COPILOT_TOAST_IDS = {
  RENAME_SUCCESS: "copilot-rename-success",
  RENAME_ERROR: "copilot-rename-error",
  STAR_SUCCESS: "copilot-star-success",
  UNSTAR_SUCCESS: "copilot-unstar-success",
  STAR_ERROR: "copilot-star-error",
  DELETE_SUCCESS: "copilot-delete-success",
};

const showToast = (type, message, toastId) => {
  if (toast.isActive(toastId)) return;
  toast[type](message, { toastId });
};

export const showCopilotRenameSuccessToast = () => {
  showToast("success", "Chat renamed successfully.", COPILOT_TOAST_IDS.RENAME_SUCCESS);
};

export const showCopilotRenameErrorToast = () => {
  showToast(
    "error",
    "Could not rename this chat. Please try again.",
    COPILOT_TOAST_IDS.RENAME_ERROR
  );
};

export const showCopilotStarredToast = () => {
  showToast("success", "Chat starred successfully.", COPILOT_TOAST_IDS.STAR_SUCCESS);
};

export const showCopilotUnstarredToast = () => {
  showToast(
    "success",
    "Chat removed from starred.",
    COPILOT_TOAST_IDS.UNSTAR_SUCCESS
  );
};

export const showCopilotStarErrorToast = () => {
  showToast(
    "error",
    "Could not update starred status. Please try again.",
    COPILOT_TOAST_IDS.STAR_ERROR
  );
};

export const showCopilotDeleteSuccessToast = (count = 1) => {
  const message =
    count === 1
      ? "Chat deleted successfully."
      : `${count} chats deleted successfully.`;

  showToast("success", message, COPILOT_TOAST_IDS.DELETE_SUCCESS);
};
